import {default as Timeline} from './timeline-base';

export default Timeline;
